/* Guia de Medidas — gaveta lateral */
(function () {
  'use strict';

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.classList.add('sg-lock');
    modal.addEventListener('keydown', trapFocus);
    var firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('sg-lock');
    modal.removeEventListener('keydown', trapFocus);
    modal.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== modal.querySelector('.sg-modal__panel')) return;
      modal.setAttribute('hidden', '');
      modal.removeEventListener('transitionend', onEnd);
    }, { once: true });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = Array.from(
      e.currentTarget.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function switchTab(modal, key) {
    modal.querySelectorAll('[data-sg-tab]').forEach(function (btn) {
      var active = btn.dataset.sgTab === key;
      btn.classList.toggle('sg-tab--active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-sg-tab-content]').forEach(function (pane) {
      var active = pane.dataset.sgTabContent === key;
      pane.classList.toggle('sg-tab-content--active', active);
    });
  }

  function init() {
    // Teleporta os modais para o <body> para escapar de qualquer ancestor
    // com transform/filter/will-change que quebraria position:fixed
    document.querySelectorAll('.sg-modal').forEach(function (m) {
      if (m.parentElement !== document.body) {
        document.body.appendChild(m);
      }
    });

    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-sg-open]');
      if (openTrigger) {
        openModal(openTrigger.dataset.sgOpen);
        return;
      }

      var closeTrigger = e.target.closest('[data-sg-close]');
      if (closeTrigger) {
        closeModal(closeTrigger.dataset.sgClose);
        return;
      }

      var tabBtn = e.target.closest('[data-sg-tab]');
      if (tabBtn) {
        var modal = tabBtn.closest('.sg-modal');
        if (modal) switchTab(modal, tabBtn.dataset.sgTab);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModal = document.querySelector('.sg-modal.is-open');
      if (openModal) closeModal(openModal.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
